
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/van/campervan",
      function () {
        return require("private-next-pages/tyres/van/campervan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/van/campervan"])
      });
    }
  